export const addresses = {
  providerAddress: "0x960183E1B28B2304F95950F6228F34EDf719365c",
  nounsArt: "0x45d8B092b0703945638f3a0880D5a7F9BC377902",
};
